import { f1AssetSources } from '../constants'

interface F1PictureProps {
  /** Asset base name without breakpoint suffix (e.g. "hero") */
  name: string
  className?: string
  alt?: string
  pictureClassName?: string
}

// Campaign art with per-breakpoint sources (project thresholds 768/1024).
const F1Picture = ({ name, className, alt = '', pictureClassName }: F1PictureProps) => {
  const src = f1AssetSources(name)
  return (
    <picture className={pictureClassName}>
      <source media="(min-width: 1024px)" srcSet={src.desktop} />
      <source media="(min-width: 768px)" srcSet={src.tablet} />
      <img className={className} src={src.mobile} alt={alt} aria-hidden={alt === '' || undefined} />
    </picture>
  )
}

export default F1Picture
